import { Row, Col } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';

import Edit from 'src/componentes/edit/edit-dialog';
import { Schema } from 'src/utils/form';
import { capitalizeFirstLetter } from 'src/utils/string';
import ConsequenciaRiscoLookup from 'src/lookups/consequencia-risco';
import useAuth from 'src/hooks/useAuth';

let schema = Schema.object({
  consequencia: Schema.string()
    .label(<FormattedMessage id="descricao" />)
    .required(),
});

const FormEdit = ({ model, disabled, riscoId }) => (
  <div className="mh-450px">
    <br />
    <Row>
      <Col md={12}>
        <Col md={6}>
          <ConsequenciaRiscoLookup
            disabled={disabled}
            model={model.getModel('consequencia')}
            data={{ riscoId: riscoId }}
          />
        </Col>
      </Col>
    </Row>
  </div>
);

const ConsequenciaEventoRiscoEdit = (props) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  return (
    <Edit
      {...props}
      parameters={{ eventoRiscoId: props.eventoRiscoId }}
      title={capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'labelConsequenciasDoRisco' },
          { consequencias: resources.consequencias, risco: resources.risco }
        )
      )}
      formComponent={FormEdit}
      afterSave={props.afterSave && props.afterSave}
      schema={schema}
      showActions={true}
      width={600}
      minHeight={240}
    />
  );
};

export default ConsequenciaEventoRiscoEdit;
